import {
  compact,
  filter,
  flatten,
  get,
  includes,
  map,
  remove,
  orderBy,
  values,
} from 'lodash'
import * as BLConstants from 'shared/constants'

import { filterPostsByType, getPostBySlug, getTopics } from '../reducers'

export const filterPostsByTopicSlug = (
  posts,
  topicSlug,
  { sortBy = 'publishedAt', order = 'desc' } = {}
) => {
  return values(
    orderBy(
      filter(posts, (post) =>
        includes(map(post.meta.topics, 'slug'), topicSlug)
      ),
      (post) => {
        return parseInt(post[sortBy])
      },
      order
    )
  )
}

export const filterPregnancyWeekByWeekPosts = (posts, topicSlug) => {
  const firstTrimesterPost = filterPostsByTopicSlug(
    posts,
    'first-trimester-of-pregnancy',
    { sortBy: 'title' }
  ).shift()
  const secondTrimesterPost = filterPostsByTopicSlug(
    posts,
    'second-trimester-of-pregnancy',
    { sortBy: 'title' }
  ).shift()
  const thirdTrimesterPost = filterPostsByTopicSlug(
    posts,
    'third-trimester-of-pregnancy',
    { sortBy: 'title' }
  ).shift()
  const results = filterPostsByTopicSlug(posts, topicSlug, {
    sortBy: 'title',
    order: 'asc',
  })
  results.splice(0, 0, firstTrimesterPost)
  results.splice(10, 0, secondTrimesterPost)
  results.splice(26, 0, thirdTrimesterPost)
  return results
}

export const filterTrimesterPosts = (posts, topicSlug) => {
  const results = filterPostsByTopicSlug(posts, topicSlug, {
    sortBy: 'title',
    order: 'asc',
  })
  results.unshift(results.pop())
  return results
}

export const getTopic = (post) => get(post, 'meta.topics[0]')

export const getTopicSlug = (post) => get(getTopic(post), 'slug')

export const getTopLevelTopicSlugFromPath = (path, posts = {}, state) => {
  const slug = path.split('/').pop()
  let topicSlug = null
  if (isTopicPage(slug, state)) {
    map(
      state.collections[BLConstants.COLLECTION_SLUG_TOPIC_NAVIGATION].items,
      (topic) => {
        if (
          includes(map(topic.children, 'slug'), slug) ||
          topic.slug === slug
        ) {
          topicSlug = topic.slug
        }
      }
    )
  } else {
    const post = getPostBySlug(slug, posts)
    topicSlug = getTopicSlug(post)
    if (post && topicSlug) {
      topicSlug = getTopLevelTopicSlugFromPath(topicSlug, posts, state)
    }
  }
  return topicSlug
}

export const isTopicPage = (slug, state) => {
  return includes(map(getTopics(state), 'slug'), slug)
}

export const getNewPosts = (posts) =>
  filterPostsByType(posts, 'article').slice(0, 5)

export const getBuildRegistryPosts = (posts, count = 9, start = 0) => {
  const guides = filterPostsByType(posts, 'guide')
  const guidesToShow = guides.slice(start, Math.ceil(count / 2))

  const samples = filterPostsByType(posts, 'sample-registry')

  // mutate samples as we pull out featured samples
  // NB: for now we are actually going to completely exclude giggle and landOfNod from the homepage sample registries
  // this is because we want leverage with them while renegotiating the advertising rates they pay us for these.
  // we can add them back in any time we need them
  const potteryBarn = remove(samples, { slug: 'pottery-barn' })
  const giggle = remove(samples, { slug: 'giggle' })
  const landOfNod = remove(samples, { slug: 'landofnod' })

  let results = compact(flatten([guidesToShow, potteryBarn]))

  if (results.length < count) {
    results = results.concat(samples.slice(start, count - results.length)) // add additional sample registries if we are below our requested count
  }

  return results
}

export const updateDOMMeta = (html) => {
  $('head .hello-baby-meta').remove()
  $('head').append(html)
}
